export default {
  title: 'Brand Settings',
  basicInfo: 'Basic Info',
};
